module.exports = __webpack_public_path__ + "img/12217_13.58895851.png";